import fetch from '@/common/axios';
export const ACCOUNT = '//account.wps.cn';
export const EDU = '//api-edu.wps.cn';
import { Message } from '@kdocs/kdesign-vue';

const POLICY_API_ORIGIN = 'https://plus.wps.cn';
const getPolicyApiUrl = (path) => `${POLICY_API_ORIGIN}${path}`;

/** 获取用户账号信息，并区分未登录与请求异常。 */
export async function queryUserInfo() {
  try {
    return await fetch.post('https://account.wps.cn/p/auth/check');
  } catch (error) {
    if (error?.result === 'userNotLogin') return null;
    throw error;
  }
}

// 退出登录
export const logout = () => {
  return fetch.post(`//account.wps.cn/p/logout`, {
    timestamp: +new Date(),
  });
};

// 获取图文分页数据
// 投放位标识:
// 首页——客户案例模块_基础教育  official_website_home_casemodule_christianity
// 首页——客户案例模块_高等教育  official_website_home_casemodule_higheducation
// 客户案例页——banner  official_website_casepage_banner
// 客户案例页——基础教育分类tab  official_website_casepage_christianity
// 客户案例页——高等教育分类tab  official_website_casepage_higheducation
// K12人工智能教学页——客户案例  official_website_solution_k12_case
// 高校人才培养页——客户案例  official_website_solution_higher_education_case
// 高校人才培养页——客户声音  official_website_solution_higher_education_voice
export const officialTextQuery = async (params) => {
  try {
    const result = await fetch.get(
      `${EDU}/operation-api/official/image/text/query?pos=${params.pos}&pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
    );
    if (result.code !== 200) {
      Message({
        message: '请求异常，请稍后再试！',
        type: 'error',
      });
      return {};
    }
    return result.data || {};
  } catch (e) {
    console.error('获取图文分页数据失败', e);
    Message({
      message: '请求异常，请稍后再试！',
      type: 'error',
    });
    return {};
  }
};

/** 获取策略平台配置数据 */
export const getPolicyData = async (params) => {
  const { windowKey, utmSource, ...rest } = params;
  if (!windowKey) {
    return Message({
      message: 'windowKey 不能为空！',
      type: 'error',
    });
  }
  const utm_source = utmSource || 'WPS365_EDU_WEB';
  const restParams = Object.keys(rest)
    .map((key) => `${key}=${rest[key]}`)
    .join('&');
  const queryString = `window_key=${windowKey}&utm_source=${utm_source}${restParams ? `&${restParams}` : ''}`;

  const result = await fetch.get(
    getPolicyApiUrl(`/ops/opsd/api/v1/policy?${queryString}`),
  );
  return result.data;
};

/**
 * 批量获取策略平台配置数据。
 * v2 接口要求 utm_source 写在每一个 entity_param 中，不能只放在请求 URL 上。
 */
export const getPolicyBatchData = async (
  windowKeys,
  utmSource = 'WPS365_EDU_WEB',
) => {
  const keys = Array.isArray(windowKeys) ? windowKeys.filter(Boolean) : [];
  if (!keys.length || typeof window === 'undefined' || !window.fetch) {
    return {};
  }

  const response = await window.fetch(
    getPolicyApiUrl('/ops/opsd/api/v2/policy'),
    {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
      },
      body: JSON.stringify({
        entity_param: keys.map((window_key) => ({
          window_key,
          utm_source: utmSource,
        })),
      }),
    },
  );

  if (!response.ok) {
    throw new Error(`策略批量请求失败：${response.status}`);
  }

  const result = await response.json();
  return (Array.isArray(result?.windows) ? result.windows : []).reduce(
    (map, item) => {
      if (item?.window_key && item.code === 0) {
        map[item.window_key] = item;
      }
      return map;
    },
    {},
  );
};

// 获取定价页面banner块的配置信息数据
export const pricePolicyQuery = async () => {
  const result = await fetch.get(
    'https://plus.wps.cn/ops/opsd/api/v1/policy?window_key=edu_wps_office_price&utm_source=WPS365_EDU_WEB',
  );
  if (!result.data) {
    return Message({
      message: '请求异常，请稍后再试！',
      type: 'error',
    });
  }
  return result.data;
};

// 获取定价页面对比权益块的配置信息数据
export const priceBatchQuery = async (names) => {
  const result = await fetch.get(
    `https://plus.wps.cn/privilege/api/v3/spackages/batch?names=${names}&priv_show_channel=compare_page`,
  );
  if (!result.data) {
    return Message({
      message: '请求异常，请稍后再试！',
      type: 'error',
    });
  }
  return result.data;
};
